<div class="grid grid-cols-12 gap-6 p-3 mb-5 bg-gray-50">
  <div class="col-span-12 lg:col-span-6 border-l-4 border-gray-700 pl-4">
    <div class="grid">
      <p class="text-xs uppercase text-gray-500 font-medium tracking-wide">
        Base Component
      </p>
      <h2 class="text-xl font-bold text-nowrap text-gray-700 leading-tight">
          Base Component
      </h2>
    </div>
  </div>
</div>

<!-- Component (grid-cols-12) --> 
<div class="grid grid-cols-12 pb-8 gap-6 px-8">
  <div class="col-span-9">     
    <main> 
      <article class="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
        <div class="prose max-w-none">
                <h2 class="text-2xl font-semibold tracking-tight">Main Card</h2>
        </div>
        <div class="mt-6 h-80 rounded-xl border border-dashed border-slate-200"></div>
      </article>
    </main>
  </div>
          
  <!-- Sidebar (col-span-3) --> 
  <div class="col-span-3">
    <div class="mb-4 bg-white p-4 rounded-2xl border border-slate-200">Latest Post Card 1</div>
    <div class="mb-4 bg-white p-4 rounded-2xl border border-slate-200">Latest Post Card 2</div>
    <div class="bg-white p-4 rounded-2xl border border-slate-200">Latest Post Card 3</div>
  </div>

   <!-- footer (col-span-12) -->      
  <footer class="col-span-12">
    <div class="mx-auto max-w-7xl px-4 py-2 text-center text-xs sm:text-sm">
        Copyright © 2025&nbsp;
        <span class="font-medium">Publio.ai</span>
        &nbsp;|&nbsp; Powered by&nbsp;
        <span class="font-medium">Brainfood SA</span>
    </div>
  </footer>
</div>